import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_EA_REQUESTER_BY_ID = "GET_EA_REQUESTER_BY_ID";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/GetRequesterById?requesterId=` + data.requesterId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EA_REQUESTER_BY_ID, service, mock);
